<template>
    <section>
        <v-row>
            <v-col cols="12" sm="12" md="6">
                <v-row>
                    <v-col cols="12" sm="12" md="3">
                        <v-btn @click="addCard = !addCard" class="info my-6">
                            <v-icon left> {{ icons.mdiDatabasePlusOutline }} </v-icon>
                            {{ addCard ? "Fermer le formulaire" : "Ajouter une nouvelle serie" }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row v-if="addCard">
            <v-col cols="12">
                <v-card>
                    <v-form v-model="valid" lazy-validation>
                        <v-card-title>Ajouter une nouvelle serie</v-card-title>
                        <v-card-text class="mt-4">
                            <v-row>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field v-model="subCategorie.label" label="Label" outlined
                                        required></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field v-model="subCategorie.labelEn" label="Label (Anglais)" outlined
                                        required></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field v-model="subCategorie.description" label="Description" outlined
                                        required></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field v-model="subCategorie.descriptionEn" label="Description (Anglais)"
                                        outlined required></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field v-model="subCategorie.seriesRank" label="Rang" outlined
                                        type="number"></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-autocomplete v-model="subCategorie.actualityCategoryId" :items="categoriesList"
                                        item-text="label" item-value="id" label="Catégorie"
                                        placeholder="Rechercher une catégorie" variant="outlined" clearable outlined />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <div class="d-flex flex-row-reverse">
                                        <v-btn :disabled="!subCategorie.label ||
                                            !subCategorie.labelEn ||
                                            !subCategorie.description ||
                                            !subCategorie.descriptionEn ||
                                            subCategorie.actualityCategoryId === null

                                            " class="info" @click="addSubCategory" :loading="isButtonLoading">
                                            {{ isButtonLoading ? "Chargement..." : "Enregistrer" }}
                                        </v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-text>

                    </v-form>
                </v-card>
            </v-col>
        </v-row>
        <v-card class="my-3">
            <br>
            <v-select v-model="selectedCategoryId" :items="categoryFilterItems" item-text="label" item-value="id"
                label="Filtrer par catégorie" placeholder="Afficher toutes les catégories" outlined clearable
                class="mx-4" />
            <v-card-title class="text-h5">
                <span style="color: #000000; font-weight: bold">
                   Liste des séries {{ selectedCategoryLabel }}
                </span>
            </v-card-title>
            <v-data-table :loading="isLoadingTables" loading-text="Loading..." :footer-props="{
                'items-per-page-options': [5, 10, 15, 30],
            }" class="elevation-1" item-key="id" :headers="headers" :items="subCategories">
                <template v-slot:[`item.actualityCategory`]="{ item }">
                    {{ item.actualityCategory || selectedCategoryLabel }}
                </template>
                <template v-slot:[`item.subCategoryList`]="{ item }">
                    {{item.subCategoryList ? item.subCategoryList.map((element) => element.label).join(',') : ''}}
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-icon @click="editSubCategory(item)">
                        {{ icons.mdiPencil }}
                    </v-icon>
                    <v-icon @click="deleteSubCategory(item)">
                        {{ icons.mdiDeleteOutline }}
                    </v-icon>
                </template>
            </v-data-table>
        </v-card>

        <!-- Dialog for editing subcategory -->
        <v-dialog v-model="dialogEdit" max-width="600px" persistent>
            <v-card>
                <v-card-title class="headline font-weight-bold">
                    Modifier la sous catégorie
                </v-card-title>
                <v-form ref="editForm" v-model="isEditValid" lazy-validation>
                    <v-card-text class="pt-4">
                        <v-row>
                            <v-col cols="12" sm="12" md="6">
                                <v-text-field v-model="subCategoryToEdit.label" label="Label *" outlined dense
                                    :rules="[(v) => !!v || 'Le label est requis']" required></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <v-text-field v-model="subCategoryToEdit.labelEn" label="Label (Anglais) *" outlined
                                    dense :rules="[(v) => !!v || 'Le label anglais est requis']"
                                    required></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <v-text-field v-model="subCategoryToEdit.description" label="Description" outlined
                                    dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <v-text-field v-model="subCategoryToEdit.descriptionEn" label="Description (Anglais)"
                                    outlined dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <v-text-field v-model="subCategoryToEdit.seriesRank" label="Rang" outlined dense
                                    type="number"></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-autocomplete v-model="subCategoryToEdit.actualityCategoryId" :items="categoriesList"
                                    item-text="label" item-value="id" label="Catégorie *"
                                    placeholder="Rechercher une catégorie" clearable outlined dense
                                    :rules="[(v) => !!v || 'La catégorie est requise']" required />
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions class="px-4 pb-4">
                        <v-spacer></v-spacer>
                        <v-btn text color="error" @click="dialogEdit = false" :disabled="loadingEdit">
                            Annuler
                        </v-btn>
                        <v-btn color="info" @click="updateSubCategory" :loading="loadingEdit"
                            :disabled="!subCategoryToEdit.label || !subCategoryToEdit.labelEn || !subCategoryToEdit.actualityCategoryId">
                            Sauvegarder
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>

        <!-- Dialog for delete confirmation -->
        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-card-title class="text-h6">
                    Confirmation de suppression
                </v-card-title>
                <v-card-text class="pt-2">
                    Êtes-vous sûr de vouloir supprimer la sous catégorie :
                    <strong>"{{ subCategoryToDelete.label }}"</strong> ?
                </v-card-text>
                <v-card-actions class="px-4 pb-4">
                    <v-spacer></v-spacer>
                    <v-btn text color="grey darken-1" @click="dialogDelete = false" :disabled="loadingDelete">
                        Annuler
                    </v-btn>
                    <v-btn color="error" @click="confirmDeleteSubCategory" :loading="loadingDelete">
                        Supprimer
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar :color="snackbar.color" v-model="snackbar.visible" :top="snackbar.position === 'top'">
            {{ snackbar.text }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar.visible = false">
                    Fermer
                </v-btn>
            </template>
        </v-snackbar>
    </section>
</template>

<script>
import constants from '@/utils/constants';
import { formatCategory } from '@/utils/formatters';
import { FetchAllSubCategories, FetchAllSubCategoriesByCategoryId, getAllActualityCategory } from '@/views/qorani/services/services';
import { mdiCancel, mdiDatabasePlusOutline, mdiDeleteOutline, mdiPencil } from '@mdi/js';
import axios from 'axios';

export default {
    data() {
        return {
            valid: true,
            snackbar: {
                text: "",
                color: "",
                visible: false,
                position: "top",
            },

            icons: {
                mdiPencil: mdiPencil,
                mdiCancel: mdiCancel,
                mdiDeleteOutline: mdiDeleteOutline,
                mdiDatabasePlusOutline: mdiDatabasePlusOutline,
            },
            headers: [
                {
                    text: 'ID',
                    value: 'id',
                    width: '80px'
                },
                {
                    text: 'Label',
                    value: 'label'
                },
                {
                    text: 'Label (Anglais)',
                    value: 'labelEn'
                },
                {
                    text: 'Description',
                    value: 'description'
                },
                {
                    text: 'Description (Anglais)',
                    value: 'descriptionEn'
                },
                {
                    text: 'Catégorie',
                    value: 'actualityCategory'
                },
                {
                    text: 'Rang',
                    value: 'seriesRank'
                },
                {
                    text: 'Actions',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: '120px'
                }
            ],
            subCategorie: {
                label: "",
                labelEn: "",
                description: "",
                descriptionEn: "",
                actualityCategoryId: null,
                seriesRank: 0
            },
            subCategories: [],
            categoriesList: [],
            categoryFilterItems: [{ id: null, label: 'Toutes les catégories' }],
            selectedCategoryId: null,
            isLoadingTables: true,
            addCard: false,
            isButtonLoading: false,

            // Edit
            dialogEdit: false,
            isEditValid: true,
            loadingEdit: false,
            subCategoryToEdit: {
                id: null,
                label: "",
                labelEn: "",
                description: "",
                descriptionEn: "",
                actualityCategoryId: null,
                seriesRank: 0
            },

            // Delete
            dialogDelete: false,
            loadingDelete: false,
            subCategoryToDelete: {
                id: null,
                label: ""
            }
        }
    },
    computed: {
        selectedCategoryLabel() {
            const category = this.categoriesList.find(item => item.id === this.selectedCategoryId);
            return category ? category.label : '';
        },
    },
    methods: {
        formatCategory,
        async loadSubCategories() {
            this.isLoadingTables = true;
            try {
                this.subCategories = this.selectedCategoryId === null
                    ? await FetchAllSubCategories()
                    : await FetchAllSubCategoriesByCategoryId(this.selectedCategoryId);
            } catch (error) {
                console.error("Error loading subcategories:", error);
                this.subCategories = [];
            } finally {
                this.isLoadingTables = false;
            }
        },
        showSnackbar(text, color = "success") {
            this.snackbar.text = text;
            this.snackbar.color = color;
            this.snackbar.visible = true;
        },
        async addSubCategory() {
            this.isButtonLoading = true;
            if (!this.subCategorie.label ||
                !this.subCategorie.labelEn ||
                !this.subCategorie.seriesRank ||
                this.subCategorie.actualityCategoryId === null) {
                this.isButtonLoading = false;
                return;
            }
            try {
                let res = await axios.post(`${constants.QORANI}actualitySubCategory/add`, this.subCategorie);
                if (res.status === 200 || res.status === 201) {
                    this.addCard = false;
                    this.subCategorie = {
                        label: "",
                        labelEn: "",
                        description: "",
                        descriptionEn: "",
                        actualityCategoryId: null,
                        seriesRank: 0
                    };
                    await this.loadSubCategories();
                    this.showSnackbar("La sous catégorie a été ajoutée avec succès !", "success");
                }
                else {
                    this.showSnackbar("La sous catégorie n'a pas été ajoutée avec succès !", "error");
                }
            } catch (error) {
                console.error("Error adding subcategory:", error);
                this.showSnackbar(error?.response?.data?.message || "La sous catégorie n'a pas été ajoutée avec succès !", "error");
            } finally {
                this.isButtonLoading = false;
            }
        },
        editSubCategory(item) {
            this.subCategoryToEdit = {
                id: item.id,
                label: item.label,
                labelEn: item.labelEn,
                description: item.description,
                descriptionEn: item.descriptionEn,
                actualityCategoryId: item.actualityCategoryId,
                seriesRank: item.seriesRank
            };
            this.dialogEdit = true;
            this.$nextTick(() => {
                if (this.$refs.editForm) {
                    this.$refs.editForm.resetValidation();
                }
            });
        },
        async updateSubCategory() {
            if (!this.subCategoryToEdit.label || !this.subCategoryToEdit.labelEn || !this.subCategoryToEdit.actualityCategoryId || !this.subCategoryToEdit.seriesRank) {
                return;
            }
            this.loadingEdit = true;
            try {
                const payload = {
                    id: this.subCategoryToEdit.id,
                    label: this.subCategoryToEdit.label,
                    labelEn: this.subCategoryToEdit.labelEn,
                    description: this.subCategoryToEdit.description,
                    descriptionEn: this.subCategoryToEdit.descriptionEn,
                    actualityCategoryId: this.subCategoryToEdit.actualityCategoryId,
                    seriesRank: this.subCategoryToEdit.seriesRank
                };
                const res = await axios.post(`${constants.QORANI}actualitySubCategory/edit/${this.subCategoryToEdit.id}`, payload);
                if (res.status === 200) {
                    this.dialogEdit = false;
                    await this.loadSubCategories();
                    this.showSnackbar("La sous catégorie a été modifiée avec succès !", "success");
                } else {
                    this.showSnackbar("Erreur lors de la modification de la sous catégorie", "error");
                }
            } catch (error) {
                console.error("Error updating subcategory:", error);
                this.showSnackbar(error?.response?.data?.message || "Erreur lors de la modification de la sous catégorie", "error");
            } finally {
                this.loadingEdit = false;
            }
        },
        deleteSubCategory(item) {
            this.subCategoryToDelete = { ...item };
            this.dialogDelete = true;
        },
        async confirmDeleteSubCategory() {
            this.loadingDelete = true;
            try {
                const res = await axios.get(`${constants.QORANI}actualitySubCategory/delete/${this.subCategoryToDelete.id}`);
                if (res.status === 200) {
                    this.dialogDelete = false;
                    await this.loadSubCategories();
                    this.showSnackbar("La sous catégorie a été supprimée avec succès !", "success");
                } else {
                    this.showSnackbar("Erreur lors de la suppression de la sous catégorie", "error");
                }
            } catch (error) {
                console.error("Error deleting subcategory:", error);
                this.showSnackbar(error?.response?.data?.message || "Erreur lors de la suppression de la sous catégorie", "error");
            } finally {
                this.loadingDelete = false;
            }
        }
    },
    async created() {
        try {
            this.categoriesList = await getAllActualityCategory();
            this.categoryFilterItems = [
                { id: null, label: 'Toutes les catégories' },
                ...this.categoriesList.map(category => ({ id: category.id, label: category.label })),
            ];
            await this.loadSubCategories();
        } catch (error) {
            console.error("Error initializing SubCategory view:", error);
            this.isLoadingTables = false;
        }
    },
    watch: {
        selectedCategoryId() {
            this.loadSubCategories();
        },
    },
}
</script>

<style></style>